/**
 * Phonics Letter Ll — 课程数据配置
 */

const MEDIA_BASE = '/media/phonics/ll';
const V = 'v1';

export const letterData = {
  letter: 'L',
  title: 'Phonics',
  subtitle: 'Letter L',

  mediaBase: MEDIA_BASE,

  // Step 1: 歌曲视频片段 (00:10-01:42)
  songVideo: {
    src: `${MEDIA_BASE}/Ll.mp4?${V}`,
    poster: `${MEDIA_BASE}/image7.png?${V}`,
    startTime: 10,
    endTime: 102,
  },

  // Step 2: 4 格单词视频 (ladybug / lion / lemon / lamp)
  wordVideos: [
    { id: 1, src: `${MEDIA_BASE}/video_s3_word1.mp4?${V}`, cover: `${MEDIA_BASE}/image8.png?${V}` },
    { id: 2, src: `${MEDIA_BASE}/video_s3_word2.mp4?${V}`, cover: `${MEDIA_BASE}/image9.png?${V}` },
    { id: 3, src: `${MEDIA_BASE}/video_s3_word3.mp4?${V}`, cover: `${MEDIA_BASE}/image10.png?${V}` },
    { id: 4, src: `${MEDIA_BASE}/video_s3_word4.mp4?${V}`, cover: `${MEDIA_BASE}/image11.png?${V}` },
  ],

  storySections: [

    // web P4: Learn the Story (1) — 00:29-00:45
    {
      label: 'Learn the Story (1)',
      layout: 'video-top-lines-bottom',
      videos: [{
        src: `${MEDIA_BASE}/Ll.mp4?${V}`,
        poster: `${MEDIA_BASE}/image13.png?${V}`,
        startTime: 29,
        endTime: 45,
      }],
      lines: [
        { en: 'Ladybug is bored, so Lion turns on the TV.', cn: '瓢虫觉得无聊，所以狮子打开电视', cnNewLine: true, audioEn: `${MEDIA_BASE}/story1_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_1.mp3?${V}` },
        { en: 'This is funny.', cn: '这个有意思', audioEn: `${MEDIA_BASE}/story1_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story1_cn_2.mp3?${V}` },
      ],
    },

    // web P5: Learn the Story (2) — 00:51-01:07
    {
      label: 'Learn the Story (2)',
      layout: 'video-top-lines-bottom',
      videos: [{
        src: `${MEDIA_BASE}/Ll.mp4?${V}`,
        poster: `${MEDIA_BASE}/image14.png?${V}`,
        startTime: 51,
        endTime: 67,
      }],
      lines: [
        { en: 'Ladybug is thirsty.', cn: '瓢虫口渴', audioEn: `${MEDIA_BASE}/story2_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_1.mp3?${V}` },
        { en: 'This is yummy.', cn: '这个味道好', audioEn: `${MEDIA_BASE}/story2_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_2.mp3?${V}` },
        { en: 'Lion sees a lemon.', cn: '狮子看到一只柠檬', audioEn: `${MEDIA_BASE}/story2_en_3.mp3?${V}`, audioCn: `${MEDIA_BASE}/story2_cn_3.mp3?${V}` },
      ],
    },

    // web P6: Learn the Story (3) — 01:13-01:29
    {
      label: 'Learn the Story (3)',
      layout: 'video-top-lines-bottom',
      videos: [{
        src: `${MEDIA_BASE}/Ll.mp4?${V}`,
        poster: `${MEDIA_BASE}/image15.png?${V}`,
        startTime: 79,
        endTime: 89,
      }],
      lines: [
        { en: 'Ladybug is sleepy, so Lion turns off the lamp.', cn: '瓢虫困了，所以狮子关上灯', audioEn: `${MEDIA_BASE}/story3_en_1.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_1.mp3?${V}` },
        { en: 'Good night.', cn: '晚安', audioEn: `${MEDIA_BASE}/story3_en_2.mp3?${V}`, audioCn: `${MEDIA_BASE}/story3_cn_2.mp3?${V}` },
      ],
    },

  ],

  // 封面背景图
  coverBg: `${MEDIA_BASE}/image1.jpeg`,

  // 视频封面图（来自 AtoZ_cover/Ll.png）
  coverPoster: `${MEDIA_BASE}/cover.png?${V}`,
};

export default letterData;
